import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import {
  ChevronDown,
  ClipboardCopy,
  Copy,
  Download,
  FilePlus2,
  MoreHorizontal,
  ShieldCheck,
} from "@/components/icons"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { buttonVariants } from "@/components/ui/button-variants"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

export function DemoAnswerTools() {
  const { t } = useTranslation()

  const handleCopyFormatted = () => {
    toast.success(t("answer.copied"))
  }

  const handleCopyRaw = () => {
    toast.success(t("answer.copied"))
  }

  const handleDownload = () => {
    toast.info(t("answer.download_answer"))
  }

  return (
    <div className="border-border/50 bg-card inline-flex items-center gap-1 rounded-full border px-2 py-1.5 shadow-sm">
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger
              className={cn(
                buttonVariants({
                  size: "icon",
                  variant: "icon",
                  className: "size-7",
                })
              )}
            >
              <Copy className="size-5" />
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
            <p>{t("answer.copy_answer")}</p>
          </TooltipContent>
        </Tooltip>
        <DropdownMenuContent align="end">
          <DropdownMenuItem className="cursor-pointer" onClick={handleCopyFormatted}>
            <Copy className="mr-2 h-4 w-4" />
            <span>{t("answer.copy_formatted", { defaultValue: "Copy formatted" })}</span>
          </DropdownMenuItem>
          <DropdownMenuItem className="cursor-pointer" onClick={handleCopyRaw}>
            <ClipboardCopy className="mr-2 h-4 w-4" />
            <span>{t("answer.copy_raw", { defaultValue: "Copy raw Markdown" })}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Tooltip>
        <TooltipTrigger
          className={cn(
            buttonVariants({
              size: "icon",
              variant: "icon",
              className: "size-7",
            })
          )}
          onClick={handleDownload}
        >
          <Download className="size-5" />
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
          <p>{t("answer.download_as")} docx</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger
          className={cn(
            buttonVariants({
              size: "icon",
              variant: "icon",
              className: "size-7",
            })
          )}
        >
          <FilePlus2 className="size-5" />
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
          <p>{t("answer.create_document", { defaultValue: "Create Document" })}</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button className="gap-2" size="sm" variant="outline">
            <ShieldCheck className="size-4" />
            {t("fact_check.button_text")}
            <Badge className="bg-primary/20 text-primary border-none" variant="outline">
              BETA
            </Badge>
            <ChevronDown className="size-3" />
          </Button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
          <p>{t("fact_check.button_tooltip")}</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger
          className={cn(
            buttonVariants({
              size: "icon",
              variant: "icon",
              className: "size-7",
            })
          )}
        >
          <MoreHorizontal className="size-5" />
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
          <p>{t("common.more_options", { defaultValue: "More options" })}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  )
}
